import axios from "axios";

import { setupInterceptorsTo } from "./interceptors";

const instance = setupInterceptorsTo(
  axios.create({
    baseURL: import.meta.env.VITE_APP_BACKEND_URL,
  }),
);

export default instance;

export { getPlayers } from "./publicRequests/players/getPlayers";
export { getTrendingPlayers } from "@repo/shared/api";
export { getCheapestItemScores } from "@repo/shared/api";
export {
  buildGalleryPlan,
  getCollectedSync,
  getGalleryCollectedPlayers,
  getGalleryPlanLimits,
  getGalleryProgress,
  getGallerySet,
  getGallerySets,
  getGallerySolution,
  setCollectedFirstOwner,
  setGalleryCompletedGrade,
  startGallerySolves,
} from "@repo/shared/api";
export { getLeaderboardSquads } from "./publicRequests/leaderboard/getLeaderboardSquads";
export { getTactics } from "./publicRequests/tactics/getTactics";
export { trackTacticUsage } from "./publicRequests/tactics/trackTacticUsage";
export { playerSearchWithMetaRatings } from "./privateRequests/squad-builder/player-search-with-metaRatings";
export { importSquad } from "./privateRequests/squad-builder/import-squad";
export { getMetaRatings } from "./privateRequests/squad-builder/get-meta-ratings";
export {
  buildObjectiveBundle,
  buildObjectiveBundleStackedPlan,
  getLatestObjectiveBundle,
  getObjectiveBundle,
  getObjectiveSquads,
  markObjectiveSquadsSaved,
  revealObjectiveBundle,
  saveObjectiveBundleProgress,
  setObjectiveBlockMode,
  setObjectiveBundleView,
  startObjectiveSquads,
  getObjectiveGroup,
  getObjectiveGroups,
} from "@repo/shared/api";
